import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-csprofileqr',
  templateUrl: './csprofileqr.component.html',
  styleUrls: ['./csprofileqr.component.css'],
  // host: {
  //   '[style.background-color]': 'backgroundColor'
  // }
})
export class CsprofileqrComponent implements OnInit, OnDestroy {

  csqrcode: string = '';
  customerBO: any = [];
  qrcodeBO: any = [];
  storeBO: any = [];
  customerData: any = [];
  submitted: boolean = false;
  saveloading: boolean = false;
  isEditMode: boolean = false;

  currentStep: 'details' | '404' = 'details';

  routerEventSubscription: Subscription = Subscription.EMPTY;

  profileform = new FormGroup({
    mobileno: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)])
  });

  registerForm = new FormGroup({
    mobileno: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    customername: new FormControl('', [Validators.required]),
    emailid: new FormControl('', [Validators.email])
  });

  constructor(
    private appService: DhukanDataService,
    private router: Router,
    private route: ActivatedRoute,
    public loginService: LoginDataService
  ) {
    this.routerEventSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.fnGetUrlParams());
  }

  ngOnInit(): void {
    this.fnGetUrlParams();
  }

  ngOnDestroy(): void {
    this.routerEventSubscription.unsubscribe();
  }

  fnGetUrlParams() {
    this.csqrcode = this.route.snapshot.paramMap.get('csqrcode') || '';
    
    if (this.csqrcode) {
      this.fnGetCustomerByCSQRCode();
    } else {
      this.currentStep = '404'; 
    }
  }

  get backgroundColor() {
    return this.qrcodeBO?.themecolor || '#01999f';
  }
  fnGetCustomerByCSQRCode() {
    var data = { qrcodetxt: this.csqrcode, formname: 'CUSTOMERQR' };
    this.saveloading = true;
    this.appService.getStoreSynccode(data).subscribe(
      (res) => {
        this.saveloading = false;
        var body = res.json();

        if (body.status === 200 && Array.isArray(body.result) && body.result.length > 0) {
          var result = body.result;
          this.customerBO = result[0]?.[0];
          this.qrcodeBO = result[2]?.[0];
          this.storeBO = result[1]?.[0];
          var customerid = this.customerBO?.customerid;
          if (customerid) {
            this.getCustomerDetails(customerid);
          } else {
            this.currentStep = '404';
          }
        } else {
          this.currentStep = '404';
        }
      },
      (err) => {
        this.saveloading = false;
        this.currentStep = '404';
      }
    );
  }
  getCustomerDetails(customerid: any) {
    var data = { customerid, synccode: this.csqrcode };
    this.saveloading = true;
    this.appService.getCustomerse(data).subscribe(
      (res: any) => {
        this.saveloading = false;
        var body = res.json();

        if (body.status === 200 && body.result?.length > 0) {
          var checkmsg = body.result?.[0]?.checkmsg;
          if (checkmsg === 'Not Exist') {
            this.currentStep = '404';
            return;
          }
          this.customerData = { ...body.result[0], customerid };
          this.currentStep = 'details'; 
        } else {
          this.currentStep = '404';
        }
      },
      (err) => {
        this.saveloading = false;
        this.currentStep = '404'; 
      }
    );
  }

  onEditProfile() {
    this.isEditMode = true;
    this.registerForm.patchValue({
      customername: this.customerData.customername || '',
      emailid: this.customerData.emailid || '',
      mobileno: this.customerData.mobileno || ''
    });
   }

  saveProfile() {
    if (this.registerForm.invalid) return;
    this.saveloading = true;
    var customerid = this.customerData?.customerid;
    var synccode = this.storeBO?.synccode;
    var updatedData = { ...this.registerForm.value, customerid, synccode };
    this.appService.setCustomer(updatedData).subscribe(
      (res: any) => {
        this.saveloading = false;
        var body = res.json();
        if (body.status === 200) {
          this.customerData = { ...this.customerData, ...updatedData };
          this.isEditMode = false;
          this.getCustomerDetails(customerid);
        } else {
          this.saveloading = false;
        } 
      },
      (err) => {
        this.saveloading = false;
      }
    );
  }

  closePopup() {
    this.isEditMode = false;
  }
}
